// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"cat"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 22C17.5228 22 22 17.6658 22 12.3193V2L16.4444 3.64493C15.1056 3.00083 13.5965 2.63866 12 2.63866C10.4035 2.63866 8.8944 3.00083 7.55556 3.64493L2 2V12.3193C2 17.6658 6.47715 22 12 22Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M22 11.7143V2L17.1389 3.43931M2 11.7143V2L6.86111 3.43931M22 12.3193C22 17.6658 17.5228 22 12 22C6.47715 22 2 17.6658 2 12.3193C2 6.97284 6.47715 2.63866 12 2.63866C17.5228 2.63866 22 6.97284 22 12.3193Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8 10V11M16 10V11M8 15C9 16.5 11 16.5 12 14.5C13 16.5 15 16.5 16 15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-cat')
export default class CatIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cat',
    }
  }
}
